// extracted by mini-css-extract-plugin
module.exports = {"liveProductList":"LiveProductList_liveProductList__WoOPY"};